import React, { useEffect } from "react";
import stechlogo from "../../assets/stech.png";
import { NavLink, Link } from "react-router-dom";
import { BiHomeAlt } from "react-icons/bi";
import { ImProfile } from "react-icons/im";
import {
  AiOutlinePlusCircle,
  AiOutlineBars,
  AiOutlineShopping,
} from "react-icons/ai";
import { TbTruckDelivery } from "react-icons/tb";
import { RiHomeSmileFill } from "react-icons/ri";
import { Divider } from "@mui/material";
import { MyContextSupply } from "../../Context";
import { useLocation } from "react-router-dom";

const AdminSidebar = () => {
  const { path, setPath, runPath, toggleRunPath } = MyContextSupply();
  const location = useLocation();
  useEffect(() => {
    setPath(location.pathname);
  }, [runPath, path]);
  return (
    <aside className="sidebar">
      <Link to="/" onClick={toggleRunPath}>
        <img
          src={stechlogo}
          alt=""
          className="admin-panel-logo"
          style={{ marginBottom: "10px" }}
        />
      </Link>
      <div className="navlikns-admin-panal">
        <NavLink to="/admin" onClick={toggleRunPath} className="admin-panal-links">
          <BiHomeAlt />
          Dashboard
        </NavLink>
        <h3 className="admin-sidebar-titles admin-sidebar-titles-others">
          Product Management
        </h3>
        <NavLink onClick={toggleRunPath} to="/add/product" className="admin-panal-links">
          <AiOutlinePlusCircle />
          Add Product
        </NavLink>
        <Divider />
        <NavLink onClick={toggleRunPath} to="/product/list" className="admin-panal-links">
          <AiOutlineBars />
          Product List
        </NavLink>
        <h3 className="admin-sidebar-titles admin-sidebar-titles-others">
          All Orders
        </h3>
        <NavLink onClick={toggleRunPath} to="/recent/orders" className="admin-panal-links">
          <AiOutlineShopping />
          Orders
        </NavLink>
        <Divider />
        <h3 className="admin-sidebar-titles">Personal Navigation</h3>
        <NavLink to="/" className="admin-panal-links">
          <BiHomeAlt />
          Home
        </NavLink>
        <Divider />
        <NavLink to="/personalinfo" className="admin-panal-links">
          <ImProfile />
          Profile
        </NavLink>
      </div>
    </aside>
  );
};

export default AdminSidebar;
